export default {
    namespaced:true,
    state: {
        blurMode: false
    },
    mutations: {
        changeBlurMode(state: any) {
            state.blurMode = !state.blurMode;
            localStorage.setItem('blurStore', JSON.stringify(state));
        },
        initialiseBlur(state: any) {
			if(localStorage.getItem('blurStore')) {
				Object.assign(state, JSON.parse(localStorage.getItem('blurStore') || '{}'));
			}
		},
    },
    getters: {
        blurMode: (state: any) => {
            return state.blurMode
        },
    },
}